export default "__VITE_ASSET__CkgCJiUM__"